import NoMatchFoundIcon from "assets/icons/NoMatchFoundIcon";
import CheckIcon from "assets/icons/CheckIcon";
import { QueryModalFilterOption } from "types";
import classNames from "classnames";

import styles from "./style.module.scss";

interface OptionProps {
  id: number;
  value: string;
  count?: string;
  selected?: boolean;
  showCheckBox: boolean;
  onSelect: (id: number) => void;
}

function Option({
  id,
  value,
  count = "",
  showCheckBox,
  selected = false,
  onSelect,
}: OptionProps) {
  const optionClassnames = classNames(styles.option, {
    [styles.checkBoxCountOption]: showCheckBox && count,
    [styles.countOption]: count && !showCheckBox,
    [styles.checkBoxOption]: showCheckBox && !count,
    [styles.selectedOption]: selected,
  });

  const checkBoxClassnames = classNames(styles.checkBox, {
    [styles.selectedCheckBox]: selected,
  });

  return (
    <div className={optionClassnames} onClick={() => onSelect(id)}>
      {showCheckBox && (
        <div className={checkBoxClassnames}>
          {selected && <CheckIcon variant="flat" />}
        </div>
      )}
      <span
        className={classNames(styles.optionText, "dropdownOptionText")}
        title={value}
      >
        {value}
      </span>

      {count && <span className={styles.count}>{count}</span>}
    </div>
  );
}

interface OptionsDropdownProps {
  selected: number[];
  multiSelect?: boolean;
  options: QueryModalFilterOption[];
  onSelect: (id: number) => void;
}

export default function OptionsDropdown({
  options,
  selected,
  multiSelect = false,
  onSelect,
}: OptionsDropdownProps) {
  return (
    <div
      className={styles.dropdownWrapper}
      data-testid="query-modal-options-dropdown"
    >
      {options.length > 0 ? (
        <div className={styles.dropdown}>
          {options.map((option) => {
            const isSelected = selected.includes(option.id);
            return (
              <Option
                id={option.id}
                key={option.id}
                count={option.count}
                value={option.text}
                showCheckBox={multiSelect}
                selected={isSelected}
                onSelect={onSelect}
              />
            );
          })}
        </div>
      ) : (
        <div className={styles.noResult}>
          <NoMatchFoundIcon />

          <span>
            No matches found
            <br />
            please try another term
          </span>
        </div>
      )}
    </div>
  );
}
